import { render, staticRenderFns } from "./App.vue?vue&type=template&id=6bcd2631&"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports